export const Logo = () => {
  return (
    <img src="/assets/images/logo.png" alt="VCCU logo" style={{height: 50}}/>
  )
};